"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _responsive = require("../responsive");

var _reactIntl = require("react-intl");

var _intlFormat = require("../../lib/intl-format");

var _translations = _interopRequireDefault(require("./translations"));

var _chevron = _interopRequireDefault(require("../../assets/icons/chevron.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UserMenu,
    isAdmin,
    indexOf = [].indexOf,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

isAdmin = function isAdmin(user) {
  var ref;
  return ref = user != null ? user.role : void 0, indexOf.call('SuperAdmin Admin Developer Sales SalesAdmin'.split(' '), ref) >= 0;
};

var _default = (0, _intlFormat.withTranslations)(_translations.default, UserMenu = function () {
  var UserMenu =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(UserMenu, _React$Component);

    function UserMenu(props) {
      var _this;

      _classCallCheck(this, UserMenu);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(UserMenu).apply(this, arguments));
      _this.toggleHostMenu = _this.toggleHostMenu.bind(_assertThisInitialized(_this));
      _this.state = {
        showHostMenu: false
      };
      return _this;
    }

    _createClass(UserMenu, [{
      key: "toggleHostMenu",
      value: function toggleHostMenu() {
        boundMethodCheck(this, UserMenu);
        return this.setState({
          showHostMenu: !this.state.showHostMenu
        });
      } // has to have hosted events or be a MUM user

    }, {
      key: "should_see_host_options",
      value: function should_see_host_options() {
        var ref, ref1, ref2;
        return !!(((ref = this.props.user) != null ? ref.is_host : void 0) || ((ref1 = this.props.user) != null ? (ref2 = ref1.memberships) != null ? ref2.length : void 0 : void 0));
      }
    }, {
      key: "render",
      value: function render() {
        var user;
        return _react.default.createElement("div", {
          className: "UserMenu"
        }, this.should_see_host_options() ? _react.default.createElement("section", null, _react.default.createElement("a", {
          href: "/dashboard",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.dashboard",
          defaultMessage: "Dashboard"
        })), _react.default.createElement("a", {
          href: "/dashboard/my-events",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.my_events",
          defaultMessage: "My Events"
        }))) : void 0, this.props.user ? _react.default.createElement("section", null, _react.default.createElement("a", {
          href: "/dashboard/tickets",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.my_tickets",
          defaultMessage: "My Tickets"
        }))) : void 0, _react.default.createElement(_responsive.ToLaptop, {
          component: "section"
        }, _react.default.createElement("a", {
          href: "/explore",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.find_events",
          defaultMessage: "Find Events"
        })), this.should_see_host_options() ? _react.default.createElement("a", {
          href: "/create",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.create_event",
          defaultMessage: "Create Event"
        })) : _react.default.createElement("div", null, _react.default.createElement("a", {
          onClick: this.toggleHostMenu,
          className: "HostMenu__dropdown--control"
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.host_events",
          defaultMessage: "Host Events"
        }), _react.default.createElement("span", {
          className: "HostMenu__dropdown--icon ".concat(this.state.showHostMenu ? 'HostMenu__dropdown--icon--open' : '')
        }, _react.default.createElement(_chevron.default, null))), _react.default.createElement("div", {
          className: "HostMenu ".concat(!this.state.showHostMenu ? 'HostMenu--hidden' : '')
        }, _react.default.createElement("a", {
          href: "/create",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.create_event",
          defaultMessage: "Create Event"
        })), _react.default.createElement("a", {
          href: "/features",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.features",
          defaultMessage: "Features"
        })), _react.default.createElement("a", {
          href: "/customers",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.customers",
          defaultMessage: "Customers"
        })), _react.default.createElement("a", {
          href: "/pricing",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.pricing",
          defaultMessage: "Pricing"
        }))))), isAdmin(this.props.user) ? _react.default.createElement("section", null, _react.default.createElement("a", {
          href: process.env.ADMIN_DOMAIN,
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.admin_panel",
          defaultMessage: "Admin panel"
        }))) : void 0, (user = this.props.user) ? _react.default.createElement("section", null, _react.default.createElement("a", {
          href: "/users/".concat(user.slug || user.id),
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.profile",
          defaultMessage: "Profile"
        })), _react.default.createElement("a", {
          href: "/dashboard/conversations",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.messages",
          defaultMessage: "Messages"
        })), _react.default.createElement("a", {
          href: "/dashboard/settings",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.settings",
          defaultMessage: "Settings"
        })), _react.default.createElement("a", {
          href: "/help",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.help",
          defaultMessage: "Help"
        })), _react.default.createElement("a", {
          href: "/users/sign_out",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.sign_out",
          defaultMessage: "Log out"
        }))) : _react.default.createElement("section", null, _react.default.createElement("a", {
          href: "/help",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.help",
          defaultMessage: "Help"
        })), _react.default.createElement("a", {
          className: "unii-skip",
          href: "/sign-in?redirectTo=".concat(window.location.href),
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.sign_in",
          defaultMessage: "Log in"
        })), _react.default.createElement("a", {
          className: "unii-skip",
          href: "/users/sign_up?redirectTo=".concat(window.location.href),
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.sign_up",
          defaultMessage: "Sign up"
        }))));
      }
    }]);

    return UserMenu;
  }(_react.default.Component);

  ;
  UserMenu.propTypes = {
    user: _propTypes.default.object,
    onNavigate: _propTypes.default.func
  };
  return UserMenu;
}.call(void 0));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/user-menu.js
// module id = 1389
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16